export default {
  VIEW_CORPORATE_ACCOUNT: "CorporateAccount",
  VIEW_CORPORATE: "Corporate",
  VIEW_CORPORATE_DOCUMENT: "CorporateDocument",
};
